<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      possibleAccountables: [
        {
          text: "Profissionais",
          value: "Professional"
        },
        {
          text: "B2C",
          value: "Physical"
        },
        {
          text: "B2B",
          value: "Legal"
        }
      ],
      possibleAccountStatus: [
        {
          text: "Email de confirmação enviado",
          id: "waiting_email_verification"
        },
        {
          text: "Esperando confirmação de email",
          id: "created"
        },
        {
          text: "Email confirmado",
          id: "email_verified"
        },
        {
          text: "Ativo",
          id: "active"
        },
        {
          text: "Inativo",
          id: "inactive"
        },
        {
          text: "Bloqueado",
          id: "blocked"
        }
      ],
      possibleAccountableStatus: {
        Professional: [
          {
            text: "Cadastro criado",
            id: "created"
          },
          {
            text: "Esperando o envio dos documentos",
            id: "waiting_for_documents"
          },
          {
            text: "Documentos em análise",
            id: "waiting_documents_validation"
          },
          {
            text: "Documento de identificação reprovados",
            id: "invalid_documents"
          },
          {
            text: "Documentosde identificação aprovados",
            id: "valid_documents"
          },
          {
            text: "Antecedentes em análise",
            id: "waiting_background_check"
          },
          {
            text: "Antecedentes reprovados",
            id: "background_check_failed"
          },
          {
            text: "Antecedentes Aprovados",
            id: "background_check_success"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState("sendNotifications", ["title", "message", "users", "userType"]),

    canSelectAccountableStatus: function() {
      return Object.keys(this.possibleAccountableStatus).includes(
        this.userType
      );
    },

    accountableStatus: function() {
      return this.possibleAccountableStatus[this.userType];
    }
  },
  methods: {
    ...mapActions("sendNotifications", [
      "setTitle",
      "setMessage",
      "setUserType",
      "setAccountStatus",
      "setAccountableStatus"
    ])
  }
};
</script>

<template>
  <v-layout column>
    <span class="mb-3">Informe o título e a mensagem da notificação.</span>
    <v-text-field
      required
      name="title"
      label="título"
      data-vv-as="título"
      prepend-inner-icon="mdi-format-title"
      v-validate="'required|max:100'"
      :counter="100"
      :value="title"
      :error="errors.has('title')"
      :error-messages="errors.first('title')"
      @input="setTitle"
    />

    <v-textarea
      required
      auto-grow
      rows="3"
      name="message"
      label="mensagem"
      prepend-inner-icon="mdi-subtitles-outline"
      v-validate="'required|max:250'"
      :counter="250"
      :value="message"
      :error="errors.has('message')"
      :error-messages="errors.first('message')"
      @input="setMessage"
    />

    <v-select
      required
      label="Selecione um tipo de usuario"
      name="users"
      prepend-inner-icon="mdi-account-search"
      :items="possibleAccountables"
      @input="setUserType"
    />

    <v-autocomplete
      chips
      multiple
      deletable-chips
      dense
      clearable
      required
      label="Selecione um status da conta"
      prepend-inner-icon="mdi-account-search"
      item-value="id"
      item-text="text"
      :items="possibleAccountStatus"
      @input="setAccountStatus"
    />

    <v-autocomplete
      chips
      multiple
      deletable-chips
      dense
      clearable
      required
      label="Selecione um ou mais status do tipo de usuário"
      prepend-inner-icon="mdi-account-search"
      item-value="id"
      item-text="text"
      v-if="canSelectAccountableStatus"
      :items="accountableStatus"
      @input="setAccountableStatus"
    />
  </v-layout>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Notifications/Send/Steps/Data.vue